var tabs = {
  init: function() {
    $('body').on('click', '.tab-item', function(e) {
      e.preventDefault();

      const that = $(this);
      const tabs = that.parents('.tabs');
      const block = that.attr('href');

      if (that.hasClass('disabled') || that.hasClass('preload')) {
        return false;
      }

      tabs.find('.tab-item').removeClass('active');
      tabs.siblings('.tab-panels').find('.tab-panel').removeClass('active');
      that.addClass('active');
      $(block).addClass('active');
    });
  }
};
